import { EXTRATO_RANGE, ExtratoActionTypes, ExtratoState } from "domain/types/_carteira/extrato/extrato";

const INITIAL_STATE: ExtratoState = {
  Extrato: []
};

export function ExtratoReducer(
  state = INITIAL_STATE,
  action: ExtratoActionTypes
): ExtratoState {
  switch (action.type) {
    case EXTRATO_RANGE:
      return { ...state, Extrato: action.payload as [] };
    default:
      return state;
  }
}